module.exports = __webpack_public_path__ + "facturtransp_v2b.08b7f8d5031efffaa9a2.png";


//////////////////
// WEBPACK FOOTER
// D:/REPO/FacturacionWeb/src/assets/images/backgrounds/facturtransp_v2b.png
// module id = ../../../../../src/assets/images/backgrounds/facturtransp_v2b.png
// module chunks = main